import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import HeaderCell from '~/glm/components/guest-list/header/header-cell.jsx';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import SortIcon from '~/glm/components/guest-list/sort-icon';

const analyticsColumnMap = {
  id: 'event',
  lastName: 'name',
};

@inject('gdsUiState', 'analyticsStore')
@observer
class SortableHeaderCell extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    numberOfHouseholds: PropTypes.number,
    entity: PropTypes.oneOf(['invitation', 'guest']).isRequired,
    sortAttr: PropTypes.string.isRequired,
    eventId: PropTypes.string,
    name: PropTypes.string.isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  };

  handleClick = direction => {
    const { gdsUiState, numberOfHouseholds, entity, sortAttr, eventId, analyticsStore } = this.props;
    if (numberOfHouseholds === 0) return null;
    let newDirection;

    if (!direction || this.newSortSelected()) newDirection = 'ascending';
    else if (direction === 'ascending') newDirection = 'descending';
    else newDirection = null;

    gdsUiState.setSort({
      sortBy: entity,
      attribute: newDirection ? sortAttr : null,
      direction: newDirection,
      eventId,
    });

    analyticsStore.track('Dashboard Interaction', {
      action: 'sort',
      column: analyticsColumnMap[sortAttr] || sortAttr,
    });
  };

  newSortSelected = () => {
    const { gdsUiState, sortAttr } = this.props;
    const currentSortAttr = gdsUiState.sort.attribute;

    return currentSortAttr && currentSortAttr !== sortAttr;
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const { gdsUiState, name, sortAttr, analyticsStore, numberOfHouseholds, ...props } = this.props;
    const direction = gdsUiState.sort.direction;

    return (
      <HeaderCell
        role="columnheader"
        aria-sort={direction}
        aria-label="sortable"
        onClick={() => this.handleClick(direction)}
        onKeyDown={e => (e.key === 'Enter' ? this.handleClick(direction) : null)}
        tabIndex={0}
        {...props}
      >
        <SortIcon
          direction={direction}
          activeSortAttr={gdsUiState.sort.attribute}
          sortAttr={sortAttr}
          label={name}
          onClick={() => this.handleClick(direction)}
        />
      </HeaderCell>
    );
  }
}

export default SortableHeaderCell;
